import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import ContentBodyBlock from 'components/ttb-home/ttb-faq/content-body-block'

const SectionBlock = ({ sectionData: { contentBody, key, title }, t }) => (
  <div key={key} className="ttb-faq__section">
    <span className={clsx('ttb-faq__section-title', Typo.h6)}>
      {hasLocizeTranslation(t, title.disabledKey, title.value)}
    </span>
    {contentBody.map((contentData) => (
      <ContentBodyBlock contentData={contentData} />
    ))}
  </div>
)

SectionBlock.propTypes = {
  sectionData: PropTypes.shape({
    contentBody: PropTypes.arrayOf(PropTypes.shape({})),
    key: PropTypes.string,
    question: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    title: PropTypes.shape({
      disabledKey: PropTypes.string,
      value: PropTypes.string,
    }),
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(SectionBlock)
